import { Injectable } from '@angular/core';
import { Throttle } from 'lodash-decorators';
import { BehaviorSubject } from 'rxjs';
import {
    CompanySettings,
    CompanySettingsUpdate,
    EmailPreferences,
    EmailPreferencesUpdate
} from '../core-data-model/CompanySettings.model';
import { CompanySettingsApi } from '../core-services/CompanySettingsApi/CompanySettingsApi.connect';
import { GeneralSettingsApi } from '../core-services/GeneralSettingsApi/GeneralSettingsApi.connect';

@Injectable({
    providedIn: 'root'
})
export class CompanySettingsService {
    public emailSettings: EmailPreferences;
    public companySettings: CompanySettings;

    public companySettingsForPI2$ = new BehaviorSubject<CompanySettings | null>(
        null
    );

    public defaultAssessmentLanguage: string;

    constructor(
        private generalSettingsApi: GeneralSettingsApi,
        private companySettingsApi: CompanySettingsApi
    ) {}

    @Throttle(1000)
    async getEmailSettings(): Promise<EmailPreferences> {
        return this.internalGetEmailSettings();
    }

    @Throttle(1000)
    async getDefaultLanguage(): Promise<string> {
        return this.internalGetDefaultLanguage();
    }

    // V4 Company settings methods. Leaving the V3 methods as they are as the V4
    // API has been decoupled from some V3 functionality
    @Throttle(1000)
    async getCompanySettings(): Promise<CompanySettings> {
        this.companySettings =
            await this.companySettingsApi.getCompanySettings();
        return this.companySettings;
    }

    async saveEmailSettings(emailSettingsUpdate: EmailPreferencesUpdate) {
        this.emailSettings =
            await this.generalSettingsApi.updateEmailSettings(
                emailSettingsUpdate
            );
    }

    async updateCompanySettings(companySettingsupdate: CompanySettingsUpdate) {
        this.companySettings =
            await this.companySettingsApi.patchCompanySettings(
                companySettingsupdate
            );
        return this.companySettings;
    }

    private async internalGetDefaultLanguage(): Promise<string> {
        this.defaultAssessmentLanguage = (
            await this.companySettingsApi.getCompanySettings()
        ).languageLocale;
        return this.defaultAssessmentLanguage;
    }

    private async internalGetEmailSettings(): Promise<EmailPreferences> {
        this.emailSettings = await this.generalSettingsApi.getEmailSetttings();
        return this.emailSettings;
    }

    /**
     * Fetches company settings for PI2.
     * @returns An BehaviorSubject of {CompanySettings}.
     */
    getCompanySettingsForPI2(): BehaviorSubject<CompanySettings | null> {
        this.companySettingsApi
            .getCompanySettingsForPI2()
            .subscribe((settings) => {
                this.companySettingsForPI2$.next(settings);
            });
        return this.companySettingsForPI2$;
    }
}
